// extracted by mini-css-extract-plugin
export default {"container":"TemplateUsers_container__JKuqS","label":"TemplateUsers_label__Ucku2","icon":"TemplateUsers_icon__opCji"};